import React from "react";
import { SoftwareInfo as CommonSoftwareInfo } from "Components";
import { PredecessorOptions } from "Types";

type SoftwareInfoProps = {
  fileName: string;
  importedFrom: string | null;
  predecessors: PredecessorOptions;
  maxVersionsLimit: number;
};

const SoftwareInfo = ({
  fileName,
  importedFrom,
  predecessors,
  maxVersionsLimit,
}: SoftwareInfoProps): React.JSX.Element => {
  return (
    <CommonSoftwareInfo.Form
      {...(importedFrom ? { importUrl: importedFrom } : { fileName })}
      predecessors={predecessors}
      maxVersionsLimit={maxVersionsLimit}
      isVersion={true}
    />
  );
};

export default SoftwareInfo;
